import request from './index';

export interface IDateFormatOption {
  value: string;
  label: string;
}

export interface IDateFormatsResponse {
  data: IDateFormatOption[];
}

/** Lista formatów daty (YYYY, MM, DD, itp.) z backendu. */
export const getDateFormats = () =>
  request<IDateFormatsResponse>({
    options: {
      url: '/date_formats',
      method: 'get'
    }
  });

